<tlc-navigation-link
  [label]="'tlc.one_settings.go_back_btn' | translate"
  [isActive]="false"
  [isChild]="false"
  [isExpanded]="true"
  [minimized]="false"
  [href]="'#'"
  [icon]="'arrow-back'"
  testId="'sidebar:settings:go-back"
  margin-bottom-medium
  (click)="goToHome($event)"
>
</tlc-navigation-link>

<tlc-navigation />
